"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWindow = void 0;
function getWindow() {
    var wd;
    try {
        wd = window;
    }
    catch (e) {
        // @ts-ignore
        wd = global;
    }
    return wd;
}
exports.getWindow = getWindow;
